(function() {

'use strict';

angular.module('ap.worklist.main')

.controller('lancer.worklist.worklistDataCtrl', ['$scope', '$controller', '$log','$modal', '$timeout', '$filter',
                                                 'model','WorkListViewSrv', 'WorkItemActionsSrv', 'csrf', 
                                                 function($scope, $controller, $log, $modal, $timeout, $filter, model, WorkListViewSrv, WorkItemActionsSrv, csrf) {
	var self = this;
	
	angular.extend(self, $controller('ap.worklist.worklistDataCtrl', {$scope: $scope}));
	
	self.performCustomAction = function(selectedWorkItem, action){
		if(action.code == 'AssignToAgent'){
			window.location = action.url + '&' + $.param(csrf);
		}
	};
	
	
}]);

})();